import { FC } from 'react';
import { Flex, OutlineButton } from '@qga/roo-ui/components';
import LoadingButton from 'components/LoadingButton';

interface LoadMoreButtonProps {
  onClick: Function;
  loading: boolean;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({ onClick, loading }) => (
  <Flex justifyContent="center" my={[5, 12]}>
    <LoadingButton
      variant="primary"
      buttonComponent={OutlineButton}
      data-testid="booking-list-load-more-button"
      onClick={onClick}
      loading={loading}
      disabled={loading}
    >
      Load more
    </LoadingButton>
  </Flex>
);

export default LoadMoreButton;
